// extracted by mini-css-extract-plugin
export default {"content":"Error_content__EpNVj","image":"Error_image__5cIVs"};